import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, Button, Divider } from '@mui/material';
import { useRsrc } from '@/common/rsrc/RsrcContext';
// import { useTheme } from '@emotion/react';

export const McdInvStatusDefinitionsDialog = () => {

  const rsrc = useRsrc();
  const [open, setOpen] = useState(true);

  const [invStatuses, setInvStatuses] = useState([]);

  // const theme = useTheme();
  
  useEffect(() => {
      rsrc.data('sc', 'MCD_INV_STATUS_DEFINITIONS_DATA_PLUGIN', {}).then(invStatuses => {
        setInvStatuses(invStatuses);
      });
  }, []);

  if (invStatuses.length === 0) return null;

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxHeight="50%">
      <DialogTitle>Invoice Status Definitions</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {invStatuses.map((s, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 1,
                borderRadius: 1,
              }}
            >
              {/* Color swatch */}
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  bgcolor: s.color,
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  flexShrink: 0,
                }}
              />

              {/* Text */}
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                  {s.displayName}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: '0.85rem' }}
                >
                  {s.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
